module.exports = __webpack_public_path__ + "img/10-oneImg.85928bb5.png";